import { Injectable, inject, signal, computed } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Injectable({ providedIn: 'root' })
export class ChatDockService {
  private readonly windowService = inject(WindowService);
  private readonly STORAGE_KEY = 'chatDockedToSiderail';

  readonly isDocked = signal(this.loadDockedState());
  readonly canDock = computed(() => this.windowService.isDesktopRes);
  readonly isEffectivelyDocked = computed(() => this.isDocked() && this.canDock());

  dock(): void {
    if (!this.canDock()) {
      return;
    }
    this.isDocked.set(true);
    this.saveDockedState(true);
  }

  undock(): void {
    this.isDocked.set(false);
    this.saveDockedState(false);
  }

  toggle(): void {
    if (this.isEffectivelyDocked()) {
      this.undock();
    } else {
      this.dock();
    }
  }

  private loadDockedState(): boolean {
    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  private saveDockedState(docked: boolean): void {
    localStorage.setItem(this.STORAGE_KEY, String(docked));
  }
}
